import React, { useEffect, useRef } from 'react';

import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { AutocompleteAddressInput } from 'components/autocomplete-address-input';

import { ISearchBarProps } from './types';

export const SearchBar = ({
  autoFocus,
  onAddressSelected,
  value,
  onInputValueChange,
}: ISearchBarProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { formatMessage } = useIntl();
  const { pathname } = useLocation();

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus, pathname]);

  return (
    <AutocompleteAddressInput
      autoFocus={autoFocus}
      required
      value={value}
      onInputValueChange={onInputValueChange}
      onAddressSelected={onAddressSelected}
      label={formatMessage({ id: 'yourAddress' })}
      aria-label={formatMessage({ id: 'enterAddressOrDrag' })}
      ref={inputRef}
      data-testid="storelocator-autocomplete"
    />
  );
};

export default SearchBar;
